import { FormControl, MenuItem, Select, Tooltip } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from "react";
import { AiOutlineSchedule, AiTwotoneSchedule } from "react-icons/ai";
import { CgClose, CgProfile } from "react-icons/cg";
import { FaRegCreditCard, FaWpforms } from "react-icons/fa";
import { IoLogOutOutline, IoPersonAddOutline } from "react-icons/io5";
import { PiHandWithdrawFill } from "react-icons/pi";
import { RiDashboardFill, RiTeamFill } from "react-icons/ri";
import { TbZoomMoney } from "react-icons/tb";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../pages/auth/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import defaultDP from '../../src/assets/images/avatar-design.png';
import clubLogoImg from "../assets/images/SportMingleLogoMark.png";
import { rootAction } from "../redux/reducer/rootReducer";
import { MdHistory, MdManageAccounts, MdOutlineEmail, MdOutlineEventNote, MdOutlineNotificationsActive, MdPersonAddAlt1 } from "react-icons/md";
import { SiOpenaccess } from "react-icons/si";
import { GrOrganization, GrScheduleNew } from "react-icons/gr";
import SideBarLink from "./SideBarLink";
import { isClubOwner, isClubStaff, isCoach, isGuest, isUser } from "../util/UserRoles";
import { TiGroup } from "react-icons/ti";
import { GoOrganization, GoTasklist } from "react-icons/go";
import { IoIosAddCircleOutline, IoIosArrowDown } from "react-icons/io";
import { setSelectedClub } from "../redux/reducer/userReducer";
import { PrivilegeAPI } from "../api/PrivilegesAPI";
import { getPlayerLabelByGame, getSidberIconByGameName } from "../util/SideBarUtil";
import CustomAccordian from "../pages/CustomComponents/CustomAccordian/CustomAccordian";
import { FaChildren } from "react-icons/fa6";
import { HiOutlineChatBubbleOvalLeftEllipsis } from "react-icons/hi2";

const SideBar = () => {
  const { signOut } = useContext(AuthContext);
  const dispatch = useDispatch();
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const { openSlideBar, sideBarLink, activeTab } = useSelector((store) => store.root);
  const [link, setLink] = useState('');
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const [privilegeList, setPrivilegeList] = useState([])


  const findLinkPrivileges = async () => {
    try {
      const response = await PrivilegeAPI.getAllPrivilegesForSideBar(userInfo.userId);
      setPrivilegeList(response.Data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userInfo.userId) {
      findLinkPrivileges();
    }
  }, [userInfo.userId])

  useEffect(() => {
    activeLink();
    setRefresh(false);
  }, [refresh, sideBarLink]);

  const handleLogout = async (e) => {
    try {
      await signOut(userInfo?.userName);
      setLink('');
      navigate("/login", { replace: true });
    } catch (err) {
    }
  };
  if (sideBarLink == '') {
    document.title = 'Dashboard';
  } else {
    if (sideBarLink) {
      document.title = sideBarLink?.replace('-', ' ')?.charAt(0).toUpperCase() + sideBarLink?.replace('-', ' ')?.slice(1).toLowerCase();
    } else {
      document.title = "Sportmingle"
    }
  }
  const activeLink = () => {
    dispatch(rootAction.setSlideBarLink(window.location.pathname.split('/').pop()));
    if (sideBarLink === "") {
      dispatch(rootAction.setActiveTab({ dashboard: true }));
    } else if (sideBarLink === "calender-setup") {
      dispatch(rootAction.setActiveTab({ calenderSetup: true }));
    } else if (sideBarLink === "calendar") {
      dispatch(rootAction.setActiveTab({ calendar: true }));
    } else if (sideBarLink === "payment-details") {
      dispatch(rootAction.setActiveTab({ payment: true }));
    } else if (sideBarLink === "players") {
      dispatch(rootAction.setActiveTab({ players: true }));
    } else if (sideBarLink === "finances") {
      dispatch(rootAction.setActiveTab({ finances: true }));
    } else if (sideBarLink === "email-notify") {
      dispatch(rootAction.setActiveTab({ notify: true }));
    } else if (sideBarLink === "plan-setup") {
      dispatch(rootAction.setActiveTab({ planSetup: true }));
    } else if (sideBarLink === "profile") {
      dispatch(rootAction.setActiveTab({ profile: true }));
    } else if (sideBarLink === "account-setup") {
      dispatch(rootAction.setActiveTab({ accountSetup: true }));
    } else if (sideBarLink === "club-setup") {
      dispatch(rootAction.setActiveTab({ clubSetup: true }));
    } else if (sideBarLink === "reservation-history") {
      dispatch(rootAction.setActiveTab({ reservationHistory: true }));
    } else if (sideBarLink === "access-management") {
      dispatch(rootAction.setActiveTab({ accessManagement: true }));
    } else if (sideBarLink === "invite-member") {
      dispatch(rootAction.setActiveTab({ inviteStaff: true }));
    } else if (sideBarLink === "coach-plan") {
      dispatch(rootAction.setActiveTab({ coachPlan: true }));
    } else if (sideBarLink === "roster") {
      dispatch(rootAction.setActiveTab({ roster: true }));
    } else if (sideBarLink === "add-org") {
      dispatch(rootAction.setActiveTab({ addOrg: true }));
    } else if (sideBarLink === "join-requests") {
      dispatch(rootAction.setActiveTab({ joinRequest: true }));
    } else if (sideBarLink === "events") {
      dispatch(rootAction.setActiveTab({ event: true }));
    } else if (sideBarLink === "my-kids") {
      dispatch(rootAction.setActiveTab({ myKids: true }));
    } else if (sideBarLink === "coach-scheduler") {
      dispatch(rootAction.setActiveTab({ scheduler: true }));
    } else if (sideBarLink === "teams") {
      dispatch(rootAction.setActiveTab({ team: true }));
    } else if (sideBarLink === "registration-setup") {
      dispatch(rootAction.setActiveTab({ registrationSetup: true }));
    } else if (sideBarLink === "event-history") {
      dispatch(rootAction.setActiveTab({ eventHistory: true }));
    } else if (sideBarLink === "chat") {
      dispatch(rootAction.setActiveTab({ chat: true }));
    }

    setRefresh(true);
  };
  const closeWithClick = () => {
    activeLink();
    if (window.innerWidth <= 1000) {
      dispatch(rootAction.setOpenSlideBar(false))
    }
  };
  const handleSelectClub = (val) => {
    if (val !== 'add') {
      const newClub = userInfo.clubs.filter((club) => club.clubId === val);
      dispatch(setSelectedClub(newClub[0]));
    }
  }
  const closeWithClickAndRedirect = () => {
    if (window.innerWidth <= 1000 && (!isUser(userInfo))) {
      dispatch(rootAction.setOpenSlideBar(false));
      dispatch(rootAction.setActiveTab({ clubProfile: true }));
      navigate('/club-setup')
    }
  };

  const getRoleNames = useCallback(() => {
    if (!userInfo?.authorities) return '';

    return userInfo.authorities
      .map(role => {
        const name = role.roleName.replace(/^ROLE_/, '').toLowerCase();
        return name.charAt(0).toUpperCase() + name.slice(1);
      })
      .join(', ');
  }, [userInfo]);



  return (
    <div
      className={
        openSlideBar
          ? "root-dashboard-sidebar active"
          : "root-dashboard-sidebar"
      }
    >
      <div className="slidebar-close">
        <CgClose
          onClick={() => dispatch(rootAction.setOpenSlideBar(!openSlideBar))}
          className="slidebar-close-icon"
        />
      </div>
      <div className="header_club_info_sidebar">
        <FormControl
          className="seleted_club_dropdown"
          sx={{ backgroundColor: 'white', borderRadius: '10px' }}
        >
          <Select
            disabled={isCoach(userInfo)}
            IconComponent={(isCoach(userInfo) || isClubOwner(userInfo)) ? () => <></> : IoIosArrowDown}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedClub?.clubId || ''}
            size="small"

            MenuProps={{
              disableScrollLock: true,
            }}
            onChange={(val) => handleSelectClub(val.target.value)}
          >
            {
              userInfo?.clubs?.map((club, index) =>
                <MenuItem sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'var(--hoverColorLightest)',
                  },
                  '&.Mui-selected:hover': {
                    backgroundColor: 'var(--hoverColorLight)',
                  },
                }} key={index} value={club?.clubId}>
                  <div className='header_club_info_item_sidebar'>
                    <img src={club?.clubLogo ? `${import.meta.env.VITE_APP_BASE_URL}/club/club-logo-img/${club?.clubLogo}` : clubLogoImg} alt="" />
                    <h2 data-testid="club_name" >{club?.clubName}</h2>
                  </div>
                </MenuItem>
              )
            }
            <MenuItem value="add">
              <div className='header_club_info_add_club' onClick={() => navigate("/add-org")}>
                <IoIosAddCircleOutline className="header_club_info_add_club_icon" />
                <p>Add Organization</p>
              </div>
            </MenuItem>
          </Select>
        </FormControl>
      </div>
      <Tooltip
        title={getRoleNames()}
        placement="right"
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'white',   // Or use theme color like 'primary.main'
              color: 'black',             // Optional: change text color
              fontSize: '14px',           // Optional
            },
          },
        }}
      >
        <div className="root-dashboard-sidebar-profile">
          <Link
            onClick={closeWithClick}
            style={{ backgroundImage: `url(${userInfo?.profileImage ? import.meta.env.VITE_APP_BASE_URL + '/user/user-profile-img/' + userInfo?.profileImage : defaultDP})` }}
            to={'/profile'}
            className="root-dashboard-sidebar-profile-img"
          >
            <span style={{ "--i": "1" }}></span>
            <span style={{ "--i": "2" }}></span>
            <span style={{ "--i": "3" }}></span>
          </Link>
          <Link
            onClick={closeWithClick}
            className="root-dashboard-sidebar-profile-name"
          >
            <p>{userInfo?.firstName + " " + userInfo?.lastName}</p>
          </Link>
        </div>
      </Tooltip>
      <div className="root-dashboard-sidebar-section">

        {/* // NOTE: Dashbord Links */}
        <div className="root-dashboard-sidebar-my-plan">
          <CustomAccordian
            title="MY ACCOUNT"
            expandIcon={getSidberIconByGameName(selectedClub?.games && selectedClub?.games[0]?.gameName)}
          >
            <SideBarLink
              to="/"
              closeWithClick={closeWithClick}
              name={"DASHBOARD"}
              activeTab={activeTab.dashboard}
              LinkIcon={RiDashboardFill}
            />
            <SideBarLink
              to="/profile"
              closeWithClick={closeWithClick}
              name={"PROFILE"}
              activeTab={activeTab.profile}
              LinkIcon={CgProfile}
            />
            {(!selectedClub.freePlanUser) &&
              <SideBarLink
                to="/payment-details"
                closeWithClick={closeWithClick}
                name={isClubOwner(userInfo) ? 'PAYMENT' : 'PAYMENT & PLAN'}
                activeTab={activeTab.payment}
                LinkIcon={FaRegCreditCard}
              />
            }
          </CustomAccordian>
        </div>

        {/* // NOTE: Reservation scheduler Links */}
        {selectedClub?.calendarType === 'RESERVATION_CALENDAR' &&
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian
              title="SCHEDULE"
              expandIcon={getSidberIconByGameName(selectedClub?.games && selectedClub?.games[0]?.gameName)}
            >
              <SideBarLink
                to="/calendar"
                closeWithClick={closeWithClick}
                name={"RESERVATION"}
                activeTab={activeTab.calendar}
                LinkIcon={AiTwotoneSchedule}
              />
              <SideBarLink
                to="/reservation-history"
                closeWithClick={closeWithClick}
                name={"RESERVATION HISTORY"}
                activeTab={activeTab.reservationHistory}
                LinkIcon={MdHistory}
              />
            </CustomAccordian>
          </div>}

        {/* // NOTE: Simple Event scheduler Links */}
        {selectedClub?.calendarType === 'EVENT_CALENDAR' &&
          <div className="root-dashboard-sidebar-my-plan">

            <CustomAccordian
              title="SCHEDULE"
              expandIcon={getSidberIconByGameName(selectedClub?.games && selectedClub?.games[0]?.gameName)}
            >
              <SideBarLink
                to="/coach-scheduler"
                closeWithClick={closeWithClick}
                name={"EVENT SCHEDULER"}
                activeTab={activeTab.scheduler}
                LinkIcon={AiOutlineSchedule}
              />
              <SideBarLink
                to="/event-history"
                closeWithClick={closeWithClick}
                name={"EVENT HISTORY"}
                activeTab={activeTab.eventHistory}
                LinkIcon={MdHistory}
              />
            </CustomAccordian>
          </div>}

        {/* // NOTE: Invite member Links */}
        {((isClubOwner(userInfo) || isClubStaff(userInfo)) && selectedClub?.clubOwner) &&
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian
              title='MEMBER'
              expandIcon={getSidberIconByGameName(selectedClub?.games && selectedClub?.games[0]?.gameName)}
            >
              <SideBarLink
                to="/players"
                closeWithClick={closeWithClick}
                name={`MANAGE ${getPlayerLabelByGame(selectedClub?.games && selectedClub?.games[0]?.gameName)?.toUpperCase()}`}
                activeTab={activeTab.players}
                LinkIcon={MdManageAccounts}
              />
              {(selectedClub?.accountSetupIsCompleted && privilegeList?.includes("MANAGE_INVITE_STAFF")) &&
                <SideBarLink
                  to="/invite-member"
                  closeWithClick={closeWithClick}
                  name={"INVITE MEMBER"}
                  activeTab={activeTab.inviteStaff}
                  LinkIcon={MdPersonAddAlt1}
                />
              }
            </CustomAccordian>
          </div>}

        {!isClubOwner(userInfo) &&
          <div className="root-dashboard-sidebar-my-plan">

            <CustomAccordian
              //title={getHighestRole(userInfo)}
              title="GUARDIAN"
              expandIcon={getSidberIconByGameName(
                selectedClub?.games && selectedClub?.games[0]?.gameName
              )}
            >
              <SideBarLink
                to="/my-kids"
                closeWithClick={closeWithClick}
                name={"MY KIDS"}
                activeTab={activeTab.myKids}
                LinkIcon={FaChildren}
              />
            </CustomAccordian>
          </div>
        }
        {(isClubOwner(userInfo) || isClubStaff(userInfo)) && (
          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian
              title="ADMIN SETTINGS"
              expandIcon={getSidberIconByGameName(selectedClub?.games && selectedClub?.games[0]?.gameName)}
            >
              {(!selectedClub?.accountSetupIsCompleted && (!selectedClub?.accountSetupIsCompleted && !isClubStaff(userInfo))) ? (
                <SideBarLink
                  to="/account-setup"
                  closeWithClick={closeWithClick}
                  name={"Account Setup"}
                  activeTab={activeTab}
                  LinkIcon={PiHandWithdrawFill}
                />
              ) : (
                <>
                  {["MANAGE_TRANSACTION", "MANAGE_PAYOUT", "MANAGE_ACCOUNT"].some(p => privilegeList?.includes(p)) &&
                    <SideBarLink
                      to="/finances"
                      closeWithClick={closeWithClick}
                      name={"MY FINANCES"}
                      activeTab={activeTab.finances}
                      LinkIcon={TbZoomMoney}
                    />}
                  <CustomAccordian
                    title="SETUP"
                    expandIcon={<IoIosArrowDown className="my-plan-dash-icon" />}
                  >
                    {privilegeList?.includes("MANAGE_FORM_TEMPLATE") &&
                      <SideBarLink
                        to="/registration-setup"
                        closeWithClick={closeWithClick}
                        name={"REGISTRATION"}
                        activeTab={activeTab.registrationSetup}
                        LinkIcon={FaWpforms}
                      />}
                    {(privilegeList?.includes("MANAGE_PLATFORM_PLAN") || privilegeList?.includes("MANAGE_CLUB_PLAN") || privilegeList?.includes("MANAGE_ONE_TIME_ACTIVATION_FEE")) &&
                      <SideBarLink
                        to="/plan-setup"
                        closeWithClick={closeWithClick}
                        name={"PLAN"}
                        activeTab={activeTab.planSetup}
                        LinkIcon={GoTasklist}
                      />}
                    {((privilegeList?.includes("MANAGE_COURT") && selectedClub.calendarType === 'RESERVATION_CALENDAR') || privilegeList?.includes("MANAGE_CLUB_TIME") || privilegeList?.includes("MANAGE_TIMEZONE_INTERVAL")) &&
                      <SideBarLink
                        to="/calender-setup"
                        closeWithClick={closeWithClick}
                        name={"CALENDAR"}
                        activeTab={activeTab.calenderSetup}
                        LinkIcon={GrScheduleNew}
                      />}
                    {privilegeList?.includes("MANAGE_CLUB_PROFILE") &&
                      <SideBarLink
                        to="/club-setup"
                        closeWithClick={closeWithClick}
                        name={"CLUB"}
                        activeTab={activeTab.clubSetup}
                        LinkIcon={GrOrganization}
                      />}
                    {isClubOwner(userInfo) &&
                      <SideBarLink
                        to="/access-management"
                        closeWithClick={closeWithClick}
                        name={"ACCESS MANAGEMENT"}
                        activeTab={activeTab.accessManagement}
                        LinkIcon={SiOpenaccess}
                      />
                    }
                  </CustomAccordian>

                  <CustomAccordian
                    title="OPERATIONS"
                    expandIcon={<IoIosArrowDown className="my-plan-dash-icon" />}
                  >

                    {privilegeList?.includes("MANAGE_EVENT") &&
                      <SideBarLink
                        to="/events"
                        closeWithClick={closeWithClick}
                        name={"EVENT"}
                        activeTab={activeTab.event}
                        LinkIcon={MdOutlineEventNote}
                      />}


                    {privilegeList?.includes("MANAGE_ROSTER") &&
                      <SideBarLink
                        to="/roster"
                        closeWithClick={closeWithClick}
                        name={"ROSTER"}
                        activeTab={activeTab.roster}
                        LinkIcon={TiGroup}
                      />}
                    {privilegeList?.includes("MANAGE_TEAM") &&
                      <SideBarLink
                        to="/teams"
                        closeWithClick={closeWithClick}
                        name={"TEAMS"}
                        activeTab={activeTab.team}
                        LinkIcon={RiTeamFill}
                      />}
                    {/* {privilegeList?.includes("MANAGE_CLUB_JOIN_REQUEST") &&
                      <SideBarLink
                        to="/join-requests"
                        closeWithClick={closeWithClick}
                        name={"JOIN REQUESTS"}
                        activeTab={activeTab.joinRequest}
                        LinkIcon={IoPersonAddOutline}
                      />} */}
                  </CustomAccordian>
                </>
              )}
            </CustomAccordian>
          </div>
        )}
        { !isGuest(userInfo) &&

          <div className="root-dashboard-sidebar-my-plan">
            <CustomAccordian
              title="COMMUNICATION"
              expandIcon={getSidberIconByGameName(selectedClub?.games && selectedClub?.games[0]?.gameName)}
            >
              {privilegeList?.includes("MANAGE_EMAIL_NOTIFICATION") &&
                <SideBarLink
                  to="/email-notify"
                  closeWithClick={closeWithClick}
                  name={"Email"}
                  activeTab={activeTab.notify}
                  LinkIcon={MdOutlineEmail}
                />}
              <SideBarLink
                to="/chat"
                closeWithClick={closeWithClick}
                name={"Chat"}
                activeTab={activeTab.chat}
                LinkIcon={HiOutlineChatBubbleOvalLeftEllipsis}
              />
            </CustomAccordian>
          </div>
        }
        {(isCoach(userInfo) || isUser(userInfo) || isGuest(userInfo) || (isUser(userInfo) && !isClubStaff(userInfo))) &&
          <CustomAccordian
            title="OPERATIONS"
            expandIcon={getSidberIconByGameName(selectedClub?.games && selectedClub?.games[0]?.gameName)}
          >
            {/* <SideBarLink
                to="/add-org"
                closeWithClick={closeWithClick}
                name={"ORGANIZATION"}
                activeTab={activeTab.addOrg}
                LinkIcon={GoOrganization}
              /> */}

            <SideBarLink
              to="/events"
              closeWithClick={closeWithClick}
              name={"EVENT"}
              activeTab={activeTab.event}
              LinkIcon={MdOutlineEventNote}
            />
            <SideBarLink
              to="/roster"
              closeWithClick={closeWithClick}
              name={"ROSTER"}
              activeTab={activeTab.roster}
              LinkIcon={TiGroup}
            />
            {privilegeList?.includes("MANAGE_TEAM") &&
              <SideBarLink
                to="/teams"
                closeWithClick={closeWithClick}
                name={"TEAMS"}
                activeTab={activeTab.team}
                LinkIcon={RiTeamFill}
              />}
          </CustomAccordian>}
      </div>
      <div className="root-dashboard-sidebar-logout">
        <h4 onClick={handleLogout}>
          <IoLogOutOutline className="root-dashboard-sidebar-logout-icon" />
          Log out
        </h4>
      </div>
    </div>
  );
};

export default SideBar;